"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createHttpReducer;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _actionHelpers = require("./actionHelpers");

var _ramda = require("ramda");

var _asyncHelpers = require("./asyncHelpers");

function createHttpReducer(actionName) {
  var defaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var customReducer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var defaultReducer = function defaultReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _defineProperty2["default"])({}, _asyncHelpers.defaultKey, defaultState);

    var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
        type = _ref2.type,
        payload = _ref2.payload,
        params = _ref2.params,
        _ref2$attrs = _ref2.attrs,
        attrs = _ref2$attrs === void 0 ? {} : _ref2$attrs,
        requestAction = _ref2.requestAction;

    var path = (0, _asyncHelpers.getPath)((0, _ramda.pathOr)(params || _asyncHelpers.noParamsKey, ['params'], requestAction));

    var getState = function getState(payload) {
      return (0, _ramda.assoc)(path, payload, state);
    };

    switch (type) {
      case (0, _actionHelpers.toSuccess)(actionName):
        return getState(payload);

      case (0, _actionHelpers.toReset)(actionName):
        return (0, _ramda.omit)([path], state);

      case (0, _actionHelpers.toLoad)(actionName):
        return !state[path] || attrs.force ? getState(payload) : state;

      default:
        return state;
    }
  };

  if (customReducer) {
    return function (state, action) {
      return customReducer(state, action, defaultReducer);
    };
  }

  return defaultReducer;
}